import { PropertyDecorator, Type } from '../reflection/types';
import { ComponentBase } from './component-base';
import { ComponentData } from './component-data';

export const ChildrenRef = (childrenType: Type<any>, selector?: string): PropertyDecorator => {
    return (target: { constructor: Type<ComponentBase<any>> }, propertyKey: string) => {
        ComponentData.registerChildrenRef(target.constructor, propertyKey, childrenType, selector);
    };
}